import {apiFetch} from 'src/api/fetch'

import {type FleetUtilization, fleetUtilizationSchema} from './schemas'

export async function getFleetUtilization(): Promise<FleetUtilization> {
    const raw = await apiFetch<unknown>('/dashboard/fleet-utilization')
    return fleetUtilizationSchema.parse(raw)
}
